<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供水流域名称" prop="processName">
              <a-input placeholder="请输入供水流域名称" v-model="model.processName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="高度偏移" prop="offsetz">
              <a-input-number placeholder="请输入高度偏移" style="width: 100%" v-model="model.offsetz" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="父节点" prop="pid">
              <j-dict-select-tag dictCode placeholder="请选择父节点" type="list" v-model="model.pid" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <!-- 子表单区域 -->
    <a-tabs @change="handleChangeTabs" v-model="activeKey">
      <a-tab-pane :forceRender="true" :key="refKeys[0]" tab="三维自定义工艺测点">
        <j-editable-table
          :actionButton="true"
          :columns="customSzwtProcessPointsTable.columns"
          :dataSource="customSzwtProcessPointsTable.dataSource"
          :disabled="formDisabled"
          :loading="customSzwtProcessPointsTable.loading"
          :maxHeight="300"
          :ref="refKeys[0]"
          :rowNumber="true"
          :rowSelection="true"
        />
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>
  import { getAction } from '@/api/manage'
  import { FormTypes, getRefPromise, VALIDATE_NO_PASSED } from '@/utils/JEditableTableUtil'
  import { JEditableTableModelMixin } from '@/mixins/JEditableTableModelMixin'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'CustomSzwtProcessForm',
    mixins: [JEditableTableModelMixin],
    components: {},
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 }
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 }
        },
        model: {},
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        validatorRules: {},
        refKeys: ['customSzwtProcessPoints'],
        tableKeys: ['customSzwtProcessPoints'],
        activeKey: 'customSzwtProcessPoints',
        // 三维自定义工艺测点
        customSzwtProcessPointsTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '点名称',
              key: 'pointName',
              type: FormTypes.input,
              width: '200px',
              placeholder: '请输入${title}',
              defaultValue: ''
            },
            {
              title: '排序',
              key: 'orderNum',
              type: FormTypes.inputNumber,
              width: '200px',
              placeholder: '请输入${title}',
              defaultValue: ''
            }
          ]
        },
        url: {
          add: '/custom/customSzwtProcess/add',
          edit: '/custom/customSzwtProcess/edit',
          queryById: '/custom/customSzwtProcess/queryById',
          customSzwtProcessPoints: {
            list: '/custom/customSzwtProcess/queryCustomSzwtProcessPointsByMainId'
          }
        }
      }
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      }
    },
    created () { },
    methods: {
      addBefore () {
        this.customSzwtProcessPointsTable.dataSource = []
      },
      getAllTable () {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter () {
        this.$nextTick(() => { })
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.requestSubTableData(this.url.customSzwtProcessPoints.list, params, this.customSzwtProcessPointsTable)
        }
      },
      //校验所有一对一子表表单
      validateSubForm (allValues) {
        return new Promise((resolve, reject) => {
          Promise.all([])
            .then(() => {
              resolve(allValues)
            })
            .catch(e => {
              if (e.error === VALIDATE_NO_PASSED) {
                // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
                this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
              } else {
                console.error(e)
              }
            })
        })
      },
      /** 整理成formData */
      classifyIntoFormData (allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          customSzwtProcessPointsList: allValues.tablesValue[0].values
        }
      },
      validateError (msg) {
        this.$message.error(msg)
      }
    }
  }
</script>

<style scoped>

</style>
